// @flow
import * as React from 'react';
import { ModerationState, Observation } from 'models';
import { CustomObservationIcon } from './CustomObservationIcon';
import './ObservationBadges.scss';
import format from 'date-fns/format';

const badgeClassName =
  'bg-moon-gray mid-gray ph2 dib f6 mb1 mr1 br1 pv1 ObservationBadge flex items-center';

export const ObservationBadge = ({
  name,
  customObservation,
}: {
  name: string,
  customObservation: boolean,
}) => {
  return (
    <span className={badgeClassName}>
      {customObservation && <CustomObservationIcon className="mr1" />}
      {name}
    </span>
  );
};

export const NoObservationsBadge = (copy: string = 'No Observations') => (
  <span className="gray pv1 ph2 dib f6 br1 mb2 bg-black-05">{copy}</span>
);

export const PwrModerationTime = ({
  moderationState,
}: {
  moderationState: ModerationState,
}) => {
  const pwrModeratedObservation = ModerationState.getSavedObservations(
    moderationState,
    1
  ).get(Observation.PowerModerationCode);

  return pwrModeratedObservation != null ? (
    <ObservationTimestamp observation={pwrModeratedObservation} showUserInfo />
  ) : null;
};

export const ObservationTimestamp = ({
  observation,
  showUserInfo,
  recent,
}: {
  observation: Observation,
  showUserInfo?: boolean,
  recent?: boolean,
}) => {
  const userInfo =
    showUserInfo && observation.user_data.name
      ? ['by ', <b key="username">{observation.user_data.name}</b>]
      : null;

  return (
    <span className="f6 db gray mb1">
      {recent === true && 'Last '}Moderated {userInfo} on{' '}
      {format(observation.created_date, 'M/DD/YYYY h:mm A')}
    </span>
  );
};

const ObservationBadges = ({
  moderationState,
}: {
  moderationState: ModerationState,
}): React.Element<any> => {
  const el = ModerationState.getSavedObservations(moderationState, 1)
    .filter(Observation.IsEditableObservation)
    .map(({ name, custom_observation }) => {
      return (
        <span key={name} className={badgeClassName}>
          {custom_observation && <CustomObservationIcon className="mr1" />}
          {name}
        </span>
      );
    })
    .toArray();

  return (
    <div className="mv2 ObservationBadges flex flex-wrap">
      {el.length ? el : NoObservationsBadge()}
    </div>
  );
};

export default ObservationBadges;



// WEBPACK FOOTER //
// ./src/components/ModerationCard/ObservationBadges.js